import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PositionStatsState, PositionStats } from '../../types/positions';

const initialState: PositionStatsState = {
  stats: null,
  loading: false,
  error: null,
};

const positionStatsSlice = createSlice({
  name: 'positionStats',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },

    setStats: (state, action: PayloadAction<PositionStats>) => {
      state.stats = action.payload;
      state.loading = false;
    },

    clearStats: () => initialState,
  },
});

export const { setLoading, setError, setStats, clearStats } =
  positionStatsSlice.actions;

export default positionStatsSlice.reducer;
